/* eslint-disable sort-keys */
/* eslint-disable prefer-destructuring */
/* eslint-disable complexity */
import React, { createContext, useContext, useMemo, useState } from 'react'
import { postSegundaAssinaturaAPI } from '../api/segundaAssinatura.servico'
import { useGlobal } from './GlobalContext'
import { isEmptyObject, objetoTemPropriedade, empty } from '../utils/helpers/helpers'
import { METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX, PLANO_ANUAL, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS } from '../constants'
import { ETAPA_BRINDES, ETAPA_CONCLUSAO, ETAPA_ENTREGA, ETAPA_PAGAMENTO, ETAPA_PLANO } from '../components/FluxosPagamento/constantsFluxosPagamento'
import {
  BASES_OBRIGATORIAS_SEGUNDA_ASSINATURA,
  BASES_OPCIONAIS_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_BRINDE_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_ENTREGA_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_PAGAMENTO_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_PLANO_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_PAGAMENTO_CARTAO_SEGUNDA_ASSINATURA,
  BASE_PROPRIEDADE_CATEGORIA_SEGUNDA_ASSINATURA
} from '../containers/Modalidade/Plano/SegundaAssinatura/constantsSegundaAssinatura'
import ErrorMessages from '../utils/adyen/ErrorMessages'
import { secondSubscriptionEvent, userDataEvent } from '../utils/events/events'
import { rdSecondSubscriptionEvent } from '../utils/events/eventsRdStation'
import { getDadosAssociado } from '../api/associado.servico'

const SegundaAssinaturaContext = createContext()

function SegundaAssinaturaProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosRetornoRequisicao': null,
    'loadingSegundaAssinatura': false,
    'sucessoSegundaAssinatura': false,
    'tipoPagamentoSegundaAssinatura': null
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <SegundaAssinaturaContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useSegundaAssinatura() {
  const context = useContext( SegundaAssinaturaContext )
  if ( !context ) {
    throw new Error( 'useSegundaAssinatura deve ser usado dentro de um SegundaAssinaturaProvider' )
  }

  const { state, setState } = context
  const { modalidadeURL, setErroRequisicao } = useGlobal()

  const setSucessoSegundaAssinatura = sucesso => {
    setState( prevState => ( {
      ...prevState,
      'sucessoSegundaAssinatura': sucesso
    } ) )
  }

  const setDadosRetornoRequisicao = dados => {
    setState( prevState => ( {
      ...prevState,
      'dadosRetornoRequisicao': dados
    } ) )
  }

  const setTipoPagamentoSegundaAssinatura = pagamento => {
    setState( prevState => ( {
      ...prevState,
      'tipoPagamentoSegundaAssinatura': pagamento
    } ) )
  }

  const setLoadingSegundaAssinatura = loading => {
    setState( prevState => ( {
      ...prevState,
      'loadingSegundaAssinatura': loading
    } ) )
  }

  const setDescontoTotalSegundaAssinatura = desconto => {
    setState( prevState => ( {
      ...prevState,
      'descontoTotalSegundaAssinatura': desconto
    } ) )
  }

  // eslint-disable-next-line max-statements
  const postSegundaAssinatura = async dadosSegundaAssinatura => {
    let objetoFinal
    let isPagamentoCartao
    let isPagamentoPix
    setLoadingSegundaAssinatura( true )
    // eslint-disable-next-line max-statements
    Object.entries( dadosSegundaAssinatura ).forEach( segundaAssinatura => {
      const [ chave, objeto ] = segundaAssinatura
      if ( !isEmptyObject( objeto ) ) {
        if ( chave === ETAPA_PLANO ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PLANO_SEGUNDA_ASSINATURA ]: { 'id': dadosSegundaAssinatura[ chave ].id ? dadosSegundaAssinatura[ chave ].id : null }
          }
        }

        if ( chave === ETAPA_BRINDES ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_BRINDE_SEGUNDA_ASSINATURA ]: objeto.id
          }
        }

        if ( chave === ETAPA_ENTREGA ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ENTREGA_SEGUNDA_ASSINATURA ]: { 'id': dadosSegundaAssinatura[ chave ].id ? Number( dadosSegundaAssinatura[ chave ].id ) : null }
          }
        }

        if ( chave === ETAPA_PAGAMENTO ) {
          const hasParcelaCartaoCredito = objetoTemPropriedade( dadosSegundaAssinatura[ chave ], 'parcela' ) ? dadosSegundaAssinatura[ chave ].parcela : 0
          const hasPromocao = objetoTemPropriedade( dadosSegundaAssinatura[ chave ], 'promocao' ) && !isEmptyObject( dadosSegundaAssinatura[ chave ].promocao ) ? dadosSegundaAssinatura[ chave ].promocao.codigo : null

          if ( dadosSegundaAssinatura[ chave ].metodoPagamento === METODO_PAGAMENTO_CARTAO.slug ) {
            isPagamentoCartao = true
            isPagamentoPix = false
          } else if ( dadosSegundaAssinatura[ chave ].metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
            isPagamentoCartao = false
            isPagamentoPix = true
          }

          if ( hasPromocao ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ]: [ hasPromocao ]
            }
          }

          const getIdBackendMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return Number( dadosSegundaAssinatura[ chave ].id )
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.idBackend
            }
          }

          const getTipoMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return METODO_PAGAMENTO_CARTAO.slugBackend
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.slugBackend
            }
          }

          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PAGAMENTO_SEGUNDA_ASSINATURA ]: {
              [ BASE_PROPRIEDADE_PAGAMENTO_CARTAO_SEGUNDA_ASSINATURA ]: {
                'cvv': isPagamentoCartao ? dadosSegundaAssinatura[ ETAPA_CONCLUSAO ].confirmacaoCVV : '',
                'id': getIdBackendMetodoPagamento()
              },
              'parcelas': isPagamentoCartao ? hasParcelaCartaoCredito : PLANO_ANUAL.parcelas,
              'tipo': getTipoMetodoPagamento()
            }
          }
        }

        if ( !empty( modalidadeURL ) ) {
          if ( modalidadeURL === MODALIDADE_CURADORIA.slug ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CATEGORIA_SEGUNDA_ASSINATURA ]: { 'id': MODALIDADE_INEDITOS.id }
            }
          } else if ( modalidadeURL === MODALIDADE_INEDITOS.slug ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CATEGORIA_SEGUNDA_ASSINATURA ]: { 'id': MODALIDADE_CURADORIA.id }
            }
          }
        }
      }
    } )

    const podeFazerSegundaAssinatura = Object.keys( objetoFinal )
      .every( chave => BASES_OBRIGATORIAS_SEGUNDA_ASSINATURA.includes( chave ) || BASES_OPCIONAIS_SEGUNDA_ASSINATURA.includes( chave ) )

    if ( podeFazerSegundaAssinatura ) {
      try {
        const { 'data': dados } = await postSegundaAssinaturaAPI( objetoFinal )
        if ( !isEmptyObject( dados.assinatura ) ) {
          setDadosRetornoRequisicao( dados.assinatura )
          setSucessoSegundaAssinatura( true )
          const dadosAssociado = ( await getDadosAssociado() ).data
          userDataEvent( {
            'email': dadosAssociado.email,
            'phone': dadosAssociado.telefone,
            'name': `${dadosAssociado.nome} ${dadosAssociado.sobrenome}`,
            'userId': dadosAssociado.id,
            'productPrice': dadosSegundaAssinatura[ ETAPA_PLANO ].valor,
            'freightPrice': dadosSegundaAssinatura[ ETAPA_ENTREGA ].frete[ 0 ].preco,
            'totalDiscount': state.descontoTotalSegundaAssinatura,
            'paymentHash': dados.cobrancaHash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ][ 0 ] : null,
            'planId': objetoFinal.plano.id,
          } )
          secondSubscriptionEvent( {
            'paymentMethod': objetoFinal.pagamento.tipo,
            'productPrice': dadosSegundaAssinatura[ ETAPA_PLANO ].valor,
            'freightPrice': dadosSegundaAssinatura[ ETAPA_ENTREGA ].frete[ 0 ].preco,
            'totalDiscount': state.descontoTotalSegundaAssinatura,
            'paymentHash': dados.cobrancaHash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_SEGUNDA_ASSINATURA ][ 0 ] : null,
            'planId': objetoFinal.plano.id,
          } )
          rdSecondSubscriptionEvent( {
            'planId': objetoFinal.plano.id,
            'email': dadosAssociado.email,
          } )
          return dados.assinatura
        }
      } catch ( erros ) {
        setSucessoSegundaAssinatura( false )
        setLoadingSegundaAssinatura( false )
        if ( erros && ( erros.request || erros.response ) ) {
          const { message } = erros.response.data.errors[ 0 ]
          if ( ErrorMessages.includes( message ) ) {
            const descricaoErro = { 'descricao': message, 'titulo': 'Houve um erro no pagamento!' }
            setErroRequisicao( erros.response.status || erros.request.status, descricaoErro )
          } else {
            setErroRequisicao( erros.response.status || erros.request.status )
          }
        }
      }
    } else {
      setLoadingSegundaAssinatura( false )
    }
  }

  return {
    'dadosRetornoRequisicao': state.dadosRetornoRequisicao,
    'loadingSegundaAssinatura': state.loadingSegundaAssinatura,
    'descontoTotalSegundaAssinatura': state.descontoTotalSegundaAssinatura,
    setDescontoTotalSegundaAssinatura,
    postSegundaAssinatura,
    setTipoPagamentoSegundaAssinatura,
    'sucessoSegundaAssinatura': state.sucessoSegundaAssinatura,
    'tipoPagamentoSegundaAssinatura': state.tipoPagamentoSegundaAssinatura,
    setLoadingSegundaAssinatura,
  }
}

export { SegundaAssinaturaProvider, useSegundaAssinatura }
